enum ToolbarOption {
  CREATE = 'CREATE',
  UPLOAD = 'UPLOAD',
  DOWNLOAD = 'DOWNLOAD',
  SHARE = 'SHARE',
  EDIT = 'EDIT',
}

export default ToolbarOption;
